import _decode from "./maps/decode.json";
var exports = {};

var __importDefault = exports && exports.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var decode_json_1 = __importDefault(_decode); // Adapted from https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119


var fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.fromCodePoint || function (codePoint) {
  var output = "";

  if (codePoint > 65535) {
    codePoint -= 65536;
    output += String.fromCharCode(codePoint >>> 10 & 1023 | 55296);
    codePoint = 56320 | codePoint & 1023;
  }

  output += String.fromCharCode(codePoint);
  return output;
};

function decodeCodePoint(codePoint) {
  if (codePoint >= 55296 && codePoint <= 57343 || codePoint > 1114111) {
    return "\uFFFD";
  }

  if (codePoint in decode_json_1.default) {
    codePoint = decode_json_1.default[codePoint];
  }

  return fromCodePoint(codePoint);
}

exports.default = decodeCodePoint;
export default exports;
export const __esModule = exports.__esModule;